import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink } from "@/types"
import OrderType, { IGetOrderTypeDto } from "./OrderType"

export interface IGetOrderTypesDto {
    entities: IGetOrderTypeDto[]
    links: IApiLink[]
}

export default class OrderTypes {
    entities: OrderType[]
    linkCreate?: IApiLink

    constructor(dto: IGetOrderTypesDto) {
        this.entities = dto.entities?.map(e => new OrderType(e)) || []
        this.linkCreate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.tenantSettingsOrderType && lnk.rel === ApiLinkRel.new)
    }
}
